// shared-components/layout/MainLayout.jsx
import PropTypes from "prop-types";
import { Suspense } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { THEME } from "@shared/constants/designSystem";
import { Outlet } from "react-router-dom";
import { useSiteGradients, useWebsite } from "@shared/hooks";
import CookieConsent from "@shared/features/cookies/CookieConsent";
import { AnnouncementBanner } from "@shared/features/announcements/AnnouncementBanner";
import PageLoader from "@shared/components/feedback/PageLoader";

function MainLayout({ children }) {
  // Get gradients from the hook
  const gradients = useSiteGradients();
  const { features } = useWebsite();

  return (
    <div
      className={`flex min-h-screen flex-col antialiased ${THEME.COLORS.TEXT.DEFAULT} transition-theme duration-theme ease-theme`}
    >
      {/* Skip Navigation Link */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary-600 focus:text-white focus:rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
      >
        Skip to main content
      </a>

      <Header />
      {features?.announcements !== false && <AnnouncementBanner />}
      <main id="main-content" className={`flex-1 ${gradients.layoutMain}`}>
        <div className="mx-auto w-full max-w-7xl px-2 sm:px-4 md:px-6 lg:px-8 py-4 sm:py-6 lg:py-8">
          <Suspense fallback={<PageLoader />}>
            {children || <Outlet />}
          </Suspense>
        </div>
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
}

MainLayout.propTypes = {
  children: PropTypes.node,
};

export default MainLayout;
